import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useData } from '../../contexts/DataContext';
import ImageUpload from '../../common/ImageUpload';

const { FiX, FiUser, FiMail, FiPhone, FiShield } = FiIcons;

const TeamModal = ({ isOpen, onClose, member }) => {
  const { addTeamMember, updateTeamMember } = useData();
  const [formData, setFormData] = useState({
    name: '', email: '', role: 'Staff', phone: '', avatar: ''
  });

  useEffect(() => {
    if (member) setFormData(member);
    else setFormData({ name: '', email: '', role: 'Staff', phone: '', avatar: '' });
  }, [member, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (member) await updateTeamMember(member.id, formData);
    else await addTeamMember(formData);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm flex items-center justify-center p-4 z-[60]">
        <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="bg-white rounded-[2.5rem] shadow-2xl w-full max-w-md overflow-hidden">
          <div className="p-8 border-b border-slate-50 flex items-center justify-between bg-slate-50/50">
            <h2 className="text-2xl font-black text-slate-900 tracking-tighter flex items-center gap-3">
              <SafeIcon icon={FiUser} className="text-blue-600" /> {member ? 'Edit Member' : 'New Team Member'}
            </h2>
            <button onClick={onClose} className="p-2 hover:bg-white rounded-xl transition-colors">
              <SafeIcon icon={FiX} className="text-slate-400" />
            </button>
          </div>
          <form onSubmit={handleSubmit} className="p-8 space-y-5 max-h-[75vh] overflow-y-auto custom-scrollbar">
            <ImageUpload 
              value={formData.avatar} 
              onChange={(url) => setFormData({ ...formData, avatar: url })} 
              label="Profile Image"
            />

            <div className="space-y-4">
              <div>
                <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest pl-1">Name</label>
                <input required className="w-full p-4 bg-slate-50 rounded-2xl border border-slate-100 outline-none font-bold" value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} />
              </div>
              <div>
                <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest pl-1">Email</label>
                <input required type="email" className="w-full p-4 bg-slate-50 rounded-2xl border border-slate-100 outline-none font-bold" value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} />
              </div>
              <div>
                <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest pl-1">Role</label>
                <select className="w-full p-4 bg-slate-50 rounded-2xl border border-slate-100 outline-none font-bold appearance-none" value={formData.role} onChange={e => setFormData({ ...formData, role: e.target.value })}>
                  <option>Staff</option>
                  <option>Manager</option>
                  <option>Admin</option>
                </select>
              </div>
            </div>

            <button type="submit" className="w-full bg-slate-900 text-white py-4 rounded-2xl font-black shadow-xl hover:bg-black transition-all">
              {member ? 'Update Member' : 'Add to Team'}
            </button>
          </form>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default TeamModal;